export const urlConfig = {
  isDeployed: true,
  ElasticSearchGet: "api/ElasticSearchGet",
  UserGet: "api/LoadUserData",
  GroupsGet: "api/Role/DisplayGroupData",
  GetGroupsDataEdit: "api/Group/GetGroupDataEdit",
  GetRoleData: "api/Role/GetRoleData",
  GetPermissionData: "api/Permission/GetPermissionData",
  GetAccountContext: "api/Account/GetAccountContext",
  GetRoleDataEdit: "api/Role/GetRoleDataEdit",
  ExcelGet: "api/ExportExcel/getexcel",
  RolesGet: "api/Role/DisplayRoleData",
  GetAccountName: "api/Account/GetAccountName",
  GetCountryAndMarket: "api/Users/GetCountryAndMarket",
  WorkInProgressGet: "api/UnMatchedAssets/GetUnMatchedAssetsDetails",
  WorkInProgressDelete: "api/UnMatchedAssets/DeleteUnMatchedAssetsDetails",
  UserGridPreferenceSave: "api/UserGridPreferences/SaveUpdate",
  UserGridPreferenceGet: "api/UserGridPreferences/GetGridPreference",
  SimpleSearch: "api/SimpleSearchGet",
  Searchfiledownload: "api/Listsearchfiledownload/GetDownload",
  fileInformation: "api/QueueManagementFileInformation",
  deleteDocuments: "api/DeleteDocuments",
  multipleDocumentsDownload:
    "api/Listsearchfiledownload/GetMultipleDocumentsDownload",
  documentViewer: "api/DocumentViewer/GetDocument",
  DownStreamLoadGrid: "api/DownStreamPageLoad",
  GetAssetHistoryDetail: "api/AssetHistory/GetAssetHistoryDetail",
  GetAntiForgeryToken: "api/AccountIdentity/antiforgerytoken",
  GetUserDataURL: "api/Auth0Login/getUserData",
  ExceptionDetails: "api/Exception/GetExceptionDetails",
  GetEmailDocument: "api/GetEmailDocument",
  EmailDocument: "api/EmailDocument",
  GetField: "api/GetFields",
  ListSearch: "api/Document/Search",
  CompareMetaData: "api/Search/CompareMetaData",
  FileDownloadApi: "api/advancedSearch/FilesGetSearchIdImage",
  GetExceptionDetails: "api/Exception/GetExceptionDetails",
  GetMenus: "api/Users/GetMenus",
  DocumentsApi: "api/ThumbnailView/GetFilesById",
  GetFoldersById: "api/FundFolders/GetFoldersById",
  GetARFDocument: "api/GetARFDocument",
  ReprocessSubSystem: "api/ReprocessSubSystem",
  ReprocessDownstreamFD: "api/ReprocessDownStream",
  ReprocessEdelivery: "api/ReprocessEdelivery",
  FileLocationDetails: "api/FileLocation/GetFileLocation",
  ExportExcel: "api/ExportExcel/getexcel",
  FileLocationDetailsById: "api/FileLocation/GetFileLocationById",
  AdvancedSearch: "api/advancedSearch/FilesGetSearchId",
  AdvancedSearchSaveQuery: "api/advancedSearch/SaveQuery",
  GetSaveQuery: "api/GetSavedQuery",
  GetSavedQueryDetails: "api/GetSavedQueryDetails",
  UpdateQuery: "api/advancedSearch/UpdateQuery",
  GetUserAcitivty: "api/UserActivity/GetUserActivity",
  CreateNew: "api/FileLocation/Add",
  PreworkSummaryGetData: "api/PreWorkSummaryLoad",
  GetInstructions: "api/GetInstruction",
  TemplateType: "api/EmailTemplate/templateType",
  GetUsersAccounts: "api/AcccountPermission/GetUsersAccounts",
  GetTemplate: "api/EmailTemplate/GetTemplate",
  AddTemplate: "api/EmailTemplate/Add",
  EmailtemplatestatusUpdate: "api/EmailTemplate/emailtemplatestatusUpdate",
  GetEmailTemplatebyID: "api/EmailTemplate/GetEmailTemplatebyID",
  GetTemplateGroup: "api/EmailTemplate/GetTemplateGroup",
  EmailTemplateUpdate: "api/EmailTemplate/EmailTemplateUpdate",
  EmailTemplateDownload: "api/ExportExcel/getexcel",
  DisplayMetaDataItem: "api/MetaDataItem/DisplayMetaDataItem",
  MetaDataItemStatusChange: "api/MetaDataItem/MetaDataItemStatusChange",
  MetaDataItemEdit: "api/MetaDataItem/MetaDataItemInsert",
  MetaDataItemInsert: "api/MetaDataItem/MetaDataItemInsert",
  ScheduleGrid: "api/PerformanceReport/ScheduleGrid",
  GetPerformanceReport: "api/GetPerformanceReport",
  ScheduleEdit: "api/PerformanceReport/ScheduleEdit",
  PreworkDetails: "api/PreWorkDetailsBindData",
  PreworkDetailDownloadDocument: "api/Search/DownloadtoFtp",
  GetHelp: "api/Help/Get",
  GetPdf: "api/HelpDocsDownload/Get",
  GetProcessStages: "api/ColumnHeaderSelection/GetProcessStages",
  GetColumnHeaderSelection:
    "api/ColumnHeaderSelection/GetColumnHeaderSelection",
  GetMetadataSelection: "api/MetadataFieldSelection/GetMetadataSelection",
  AuthUpdate: "api/Account/AuthUpdate",
  GetPermissions: "api/Permission/GetPermissions",
  GetActivityReport: "api/ActivityReport/GetActivityReport",
  GetActivityReportDetail: "api/ActivityReport/GetActivityReportDetail",
  ActivityReportScheduleGrid: "api/ScheduleActivityReport/ScheduleGrid",
  DisplayProcessStageItem: "api/ProcessStage/DisplayProcessStageItem",
  GetAccount: "api/EmailTemplate/GetAccount",
  DisplayMenuItem: "api/MenuItem/DisplayMenuItem",
  AccountByUser: "api/Account/GetAccountByUser",
  SourceDetails: "api/SourceDetails/GetAll",
  ActiveFileLocation: "api/FileLocation/GetActiveFileLocation",
  MetadataColumns: "api/FileLocation/GetMetadataColumns",
  Folders: "api/FundFolders/GetFolders",
  AddSourceConfig: "api/SourceDetails/Add",
  SubSystemMetadata: "api/SubSystem/GetSubSystemdata",
  getexcel: "api/ExportExcel/getexcel",
  GetGroupName: "api/MetadataGroup/GetGroupName",
  GetGroupDataEdit: "api/MetadataGroup/GetGroupDataEdit",
  GetMappingName: "api/MetaDataMapping/DisplayGrid",
  GetMetadataMappingEdit: "api/MetaDataMapping/GetMetadataMappingConfiguartion",
  GetMetadataMappingConfiguartion:
    "api/MetaDataMapping/GetMetadataMappingConfiguartion",
  MetaDataGroupStatusChange: "api/MetadataGroup/MetaDataGroupStatusChange",
  CreateGroup: "api/MetadataGroup/CreateGroup",
  MetadatamappingInsert: "api/MetaDataMapping/MetadatamappingInsert",
  CreateSubSystem: "api/SubSystem/CreateSubSystem",
  GetArchivalReport: "api/GetArchivalReport",
  GetDownload: "api/Listsearchfiledownload/GetDownload",
  QueueManagementFileInformation: "api/QueueManagementFileInformation",
  RenameFiles: "api/PreworkDetailsInstructionRenameFiles",
  RejectFiles: "api/PreworkDetailsRejectFiles",
  PreDetailsAddinstructionsText: "api/AddinstructionText/Add",
  DeleteFiles: "api/PreworkDetailsDeleteFiles",
  AcceptPreworkDetails: "api/PreWorkDetailsAccept",
  MoveToPreflight: "api/MoveFileToPreflight",
  GetPreWorkInstructions: "api/GetPreWorkInstructions",
  MoveToFinalFolder: "api/MoveFileToFinal",
  TriggerProofWorkFlow: "api/TriggerProofWorkFlow",
  TriggerProdWorkFlow: "api/TriggerProdWorkFlow",
  ReprocessFileMoveToPreflight: "api/ReprocessFileMoveToPreflight",
  PreDetailsUploadToServer: "api/Upload/SaveUpdate",
  UploadToServer: "api/Upload/SaveUpdateDelete",
  GetEditMetadataOrderdefinition:
    "api/MetaDataDefnition/GetEditMetadataOrderdefinition",
  GetMetadataOrderdefinition:
    "api/MetaDataDefnition/GetMetadataOrderdefinition",
  DocViewSaveDetails: "api/SaveDocViewDetails",
  GetDefinitionName: "api/MetaDataDefnition/MetaDataDefinitionDisplayGrid",
  MetadataDefinitionConfiguartion:
    "api/MetaDataDefnition/MetadataDefinitionConfiguartion",
  GetAvailableMetadatadefinition: "api/MetaDataDefnition/GetMetadatadefinition",
  MetadatadefinitionInsert: "api/MetaDataDefnition/MetadatadefinitionInsert",
  ResentAPIUserPassword: "api/User/ResentAPIUserPassword",
  RemoveSubsystemdata: "api/SubSystem/RemoveSubsystemdata",
  GetClients: "api/Account/GetClients",
  GetClientDetail: "api/Account/GetClientDetails",
  GetFundFolder: "api/FundFolders/GetFolders",
  GetAccountMetaData: "api/Account/GetAccountMetaDataFields",
  TemplateMappings: "api/EmailTemplateMapping/Templatemappings",
  GetEmailTemplateGroup: "api/EmailTemplateMapping/GetEmailTemplateGroup",
  GetEmailTemplateFields: "api/EmailTemplateMapping/GetEmailTemplateFields",
  CreateEmailMapping: "api/EmailTemplateMapping/CreateEmailMapping",
  GetEmailTemplateMappingbyId:
    "api/EmailTemplateMapping/GetEmailTemplateMappingbyId",
  ProcessStageStatusChange: "api/ProcessStage/ProcessStageStatusChange",
  ProcessStageInsertUpdate: "api/ProcessStage/ProcessStageInsertUpdate",
  MenuStatusChange: "api/MenuItem/MenuStatusChange",
  MenuItemInsertUpdate: "api/MenuItem/MenuItemInsertUpdate",
  UpdateAccountsBySwitch: "api/AccountPermission/UpdateAccountsBySwitch",
  GetAccountByUserForEnv: "api/Account/GetAccountByUser",
  GetRequesterAccountForEnv: "api/RequesterConfig/GetRequesterAccount",
  Profilenamedelete: "api/SubSystem/Profilenamedelete",
  GetAccountById: "api/Account/GetAccount",
  GetAccountLogo: "api/Account/GetAccountLogo",
  AddNewAcount: "api/Account/AddAccount",
  GetFieldsOfReports: "api/GetFields",
  SaveQuery: "api/advancedSearch/SaveQuery",
  GetSavedQuery: "api/GetSavedQuery",
  SaveUpdateDelete: "api/Users/SaveUpdateDelete",
  UserActiveStatus: "api/Users/UserActiveStatus",
  Schedule: "api/ScheduleFileInfoReport/Schedule",
  FileInfoReports: "api/advancedSearch/FileInfoReports",
  Useractivity: "/api/Activity/Useractivity",
  DeleteUser: "api/DeleteUser",
  CreateGroups: "api/Group/CreateGroup",
  GroupIDExists: "api/Group/GroupIDExists",
  GroupStatusChange: "api/Group/GroupStatusChange",
  RolesStatusChange: "api/Role/RoleStatusChange",
  CreateRole: "api/Role/CreateRole",
  SaveUpdateDeleteExcelData: "api/EmailTemplate/SaveUpdateDeleteExcelData",
  PreDetailsAddinstructions: "api/Addinstruction/Add",
  FileLocationUpload: "api/FTPTemplate/SaveUpdateDeleteExcelData",
  MultipleDocsDownload: "api/GetMultipleDocuments",
  PerformanceReportAddEdit: "api/PerformanceReport/Schedule",
  ColumnHeaderSelection: "api/MetaDataMapping/ColumnHeaderSelectionInsert",
  GetFolderAccessRights: "api/FundFolders/GetFolderAccessRights",
  SaveFolderAccessRightsPermission:
    "api/FundFolders/SaveFolderAccessRightsPermission",
  ScheduleActivityReport: "api/ScheduleActivityReport/Schedule",
  ScheduleActivityReportEdit: "api/ScheduleActivityReport/ScheduleEdit",
  FoldersGetByLevels: "api/FundFolders/FoldersGetByLevels",
  DocumentFileUpload: "api/Upload/CustomFileUpload",
  SaveArchivalReport: "api/SaveArchivalReport",
  UpdateQueryReport: "api/advancedSearch/UpdateQuery",
  DashboardCounts: "api/DashboardCounts",
  GetPreworkDashboardDetails: "api/GetPreworkDashboardDetails",
  GetDownStreamDetails: "api/GetDownStreamDetails",
  GetDuplicateUserCheck: "api/Users/CheckUserDuplicateInMaster",
  PasswordResetURL: "api/User/Password/ResetURL",
  PreworkExportToExcel: "api/ExportExcel/getexcel",
  GetApiIngestionDetails: "api/ApiIngestion/GetApiIngestion",
  DeleteFileLocationById: "api/FileLocation/DeleteFileLocationById",
  getPendingMessages: "api/PendingMessages",
  DQDeptCount: "api/DQAdapterQDeptCount",
  DecryptUrl: "api/DecryptURL",
};
